import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createSvcGroup, deleteSvcGroup as _deleteSvcGroup, deleteSvcGroupByIds, updateSvcGroup, findSvcGroup, getSvcGroupList } from '@/api/bairun/svcGroup'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'SvcGroup',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getOilCodeNames: function getOilCodeNames(oilCodes) {
      var oilCodeArr = oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    }
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])),
  components: {
    SearchTerm: SearchTerm
  },
  data: function data() {
    return {
      listApi: getSvcGroupList,
      loading: false,
      searchInfo: {
        // 按配置顺序显示
        'groupName': '',
        'isCashierShow': '',
        'cashierShowStations': ''
      },
      dialogFormVisible: false,
      dialogTitle: '',
      type: '',
      deleteVisible: false,
      multipleSelection: [],
      oilCodesCheckAll: true,
      oilCodesChecked: [],
      oilCodesOptions: [],
      formData: {
        sellerId: '',
        groupName: '',
        isCashierShow: 0,
        cashierShowStations: '',
        remark: ''
      },
      stationCheckAll: false,
      stationIdChecked: [],
      rules: {
        groupName: [{
          required: true,
          message: '请输入群名称',
          trigger: 'blur'
        }],
        sellerId: [{
          required: true,
          message: '请选择油站',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getDict('oilCode');

              case 2:
                _this3.oilCodesOptions = _context3.sent;

                _this3.handleCheckAllChange(true);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 油站全选
    handleStationCheckAllChange: function handleStationCheckAllChange(val) {
      this.stationIdChecked = val ? this.allStations.map(function (item) {
        return item.ID;
      }) : [];
      this.stationCheckAll = this.stationIdChecked.length === this.allStations.length;

      if (this.stationCheckAll) {
        this.formData.cashierShowStations = '-1';
      } else {
        this.formData.cashierShowStations = '';
      }

      console.log('油站全选', this.formData.cashierShowStations);
    },
    // 油站勾选
    handleCheckedStationChange: function handleCheckedStationChange(value) {
      this.stationCheckAll = value;
      this.formData.cashierShowStations = value.toString();
      console.log('油站勾选', this.formData.cashierShowStations);
    },
    // 条件搜索前端看此方法
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;
                _context4.next = 5;
                return _this4.getTableData();

              case 5:
                _this4.loading = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSelectStationChange: function onSelectStationChange() {
      if (this.formData.sellerId == 0) {
        this.formData.groupName = '所有油站-';
      } else {
        this.formData.groupName = this.asyncStationsMap[String(this.formData.sellerId)].stationName + '-';
      }
    },
    deleteRow: function deleteRow(row) {
      var _this5 = this;

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.deleteSvcGroup(row);
      }).catch(function (err) {});
    },
    onBattchDelete: function onBattchDelete() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.$confirm('确定要批量删除吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  _this6.handleBattchDelete();
                }).catch(function (err) {});

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleBattchDelete: function handleBattchDelete() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                ids = [];

                if (!(_this7.multipleSelection.length === 0)) {
                  _context6.next = 4;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '请选择要删除的数据'
                });

                return _context6.abrupt("return");

              case 4:
                _this7.multipleSelection && _this7.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context6.next = 7;
                return deleteSvcGroupByIds({
                  ids: ids
                });

              case 7:
                res = _context6.sent;

                if (res.code === 0) {
                  _this7.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this7.tableData.length === ids.length && _this7.page > 1) {
                    _this7.page--;
                  }

                  _this7.deleteVisible = false;

                  _this7.getTableData();
                }

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    updateSvcGroup: function updateSvcGroup(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, res, arr;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                debugger;
                that = _this8;
                that.oilCodesChecked = [];
                that.stationIdChecked = [];
                _context7.next = 6;
                return findSvcGroup({
                  ID: row.ID
                });

              case 6:
                res = _context7.sent;
                that.type = 'update';

                if (res.code === 0) {
                  that.formData = res.data.resBairunSvcGroup; // 油站勾选

                  if (that.formData.cashierShowStations == '-1') {
                    that.handleStationCheckAllChange(true);
                  } else if (that.formData.cashierShowStations == '') {} else {
                    arr = res.data.resBairunSvcGroup.cashierShowStations.split(',');
                    arr.forEach(function (item) {
                      that.stationIdChecked.push(parseInt(item));
                    });
                  }

                  that.dialogFormVisible = true;
                  that.dialogTitle = '变更操作';
                }

                that.$forceUpdate;

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.oilCodesChecked = [];
      this.oilCodesCheckAll = false;
      this.stationCheckAll = false;
      this.stationIdChecked = [];
      this.formData = {
        isCashierShow: 0,
        cashierShowStations: '',
        groupName: '',
        remark: ''
      };
    },
    deleteSvcGroup: function deleteSvcGroup(row) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _deleteSvcGroup({
                  ID: row.ID
                });

              case 2:
                res = _context8.sent;

                if (res.code === 0) {
                  _this9.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this9.tableData.length === 1) {
                    _this9.page--;
                  }

                  _this9.getTableData();
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    formatFormData: function formatFormData() {
      var formData = JSON.parse(JSON.stringify(this.formData));
      formData.sellerId = parseInt(formData.sellerId);
      return formData;
    },
    enterDialog: function enterDialog() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var that;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                that = _this10;
                _context9.t0 = that.type;
                _context9.next = _context9.t0 === 'create' ? 4 : _context9.t0 === 'update' ? 6 : 8;
                break;

              case 4:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    createSvcGroup(_this10.formatFormData()).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context9.abrupt("break", 9);

              case 6:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    updateSvcGroup(_this10.formatFormData()).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context9.abrupt("break", 9);

              case 8:
                return _context9.abrupt("break", 9);

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '创建/更改成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    openDialog: function openDialog() {
      this.type = 'create';
      this.dialogFormVisible = true;
      this.dialogTitle = '新增操作';
      this.handleCheckAllChange(true);
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.oilCodesChecked = val ? this.oilCodesOptions.map(function (oil) {
        return oil.value;
      }) : [];
      this.oilCodesCheckAll = this.oilCodesChecked.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.formData.oilCodes = '-1';
      } else {
        this.formData.oilCodes = '';
      }
    },
    handleCheckedOilCodesChange: function handleCheckedOilCodesChange(value) {
      this.oilCodesCheckAll = value.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.handleCheckAllChange(true);
      } else {
        this.formData.oilCodes = value.join(',');
      }
    }
  }
};